<template>
  <b-container class="bv-example-row" fluid>
    <b-row align-h="between">
      <b-col cols="auto">
        <h3>รายการตรวจย่อยของ {{ testName }}</h3>
      </b-col>
      <b-col cols="auto">
        <b-button variant="success" @click="openFieldModal(null)">
          เพิ่มรายการตรวจ
        </b-button>
      </b-col>
    </b-row>
    <b-row align-h="start">
      <b-col cols="auto">
        <b-button @click="backHandler">
          ย้อนกลับ
        </b-button>
      </b-col>
    </b-row>
    <b-row style="padding-top: 2rem;">
      <b-table
        responsive
        striped
        hover
        bordered
        :fields="fields"
        :items="subTests"
      >
        <template slot="id" slot-scope="data">
          <div class="col-right">
            {{ data.item.id }}
          </div>
        </template>
        <template slot="unit" slot-scope="data">
          <div class="col-left">
            {{ data.item.unit ? data.item.unit : "" }}
          </div>
        </template>
        <template slot="price" slot-scope="data">
          <div class="col-right">
            {{ data.item.price }}
          </div>
        </template>
        <template slot="abbreviation" slot-scope="data">
          <div class="col-left">
            {{ data.item.abbreviation }}
          </div>
        </template>
        <template slot="sequence" slot-scope="data">
          <div class="col-right">
            <b-row>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'caret-up']"
                  :class="{
                    icon: true,
                    disable: checkMinMax(
                      data.item.sequence,
                      subTests,
                      'sequence',
                      'min'
                    ),
                  }"
                  @click="changePositionHandler(data.item.id, 'up')"
                />
              </b-col>
              <b-col cols="auto">
                <fa-icon
                  :icon="['fas', 'caret-down']"
                  :class="{
                    icon: true,
                    disable: checkMinMax(
                      data.item.sequence,
                      subTests,
                      'sequence',
                      'max'
                    ),
                  }"
                  @click="changePositionHandler(data.item.id, 'down')"
                />
              </b-col>
              <b-col cols="auto">
                {{ data.item.sequence }}
              </b-col>
            </b-row>
          </div>
        </template>
        <template slot="unit" slot-scope="data">
          <div class="col-left">
            {{ data.item.unit }}
          </div>
        </template>

        <template slot="machine_id" slot-scope="data">
          <div class="col-left">
            {{ data.item.machine ? data.item.machine.name : "" }}
          </div>
        </template>

        <!--                <template slot="test_type_id" slot-scope="data">-->
        <!--                    <div class="col-left">-->
        <!--                        {{data.item.test__type ? data.item.test__type.name : ''}}-->
        <!--                    </div>-->
        <!--                </template>-->

        <template slot="action" slot-scope="data">
          <b-container fluid>
            <b-row align-h="center">
              <b-col cols="auto">
                <!--                            <fa-icon-->
                <!--                                :icon="['fas', 'arrow-right']"-->
                <!--                                class="icon"-->
                <!--                                @click="openSubTestHandler(data.item.id)"-->
                <!--                                v-if="data.item.has_sub_test || data.item.input_type === 'heading'"-->
                <!--                            />-->
                <b-button
                  v-if="
                    data.item.has_sub_test || data.item.input_type === 'heading'
                  "
                  class="button btn-dark"
                  @click="openSubTestHandler(data.item.id)"
                >
                  ดูรายละเอียด
                </b-button>
              </b-col>
              <b-col cols="auto">
                <!--                                <fa-icon-->
                <!--                                    :icon="['fas', 'edit']"-->
                <!--                                    class="icon warning"-->
                <!--                                    @click="openFieldModal(data.item.id)"-->

                <!--                                />-->
                <b-button
                  class="button btn-warning"
                  @click="openFieldModal(data.item.id)"
                >
                  แก้ไข
                </b-button>
                <!--                                <b-button variant="warning" @click="openFieldModal(data.item.id)">-->
                <!--                                    แก้ไข-->
                <!--                                </b-button>-->
              </b-col>
              <b-col cols="auto">
                <!--                                <fa-icon-->
                <!--                                    :icon="['fas', 'trash']"-->
                <!--                                    class="icon danger"-->
                <!--                                    @click="openDeleteModal(data.item.id)"-->

                <!--                                />-->
                <b-button
                  class="button btn-danger"
                  @click="openDeleteModal(data.item.id)"
                >
                  ลบ
                </b-button>
                <!--                                <b-button variant="danger" @click="openDeleteModal(data.item.id)">-->
                <!--                                    ลบ-->
                <!--                                </b-button>-->
              </b-col>
            </b-row>
          </b-container>
        </template>
      </b-table>
      <div v-if="subTests.length === 0" class="row" style="margin:auto">
        <span>ไม่มีข้อมูล</span>
      </div>
    </b-row>
    <b-modal
      ref="inputModal"
      :title="modalTitle"
      size="xl"
      :no-enforce-focus="true"
      @ok="submit"
      @cancel="resetSubTestInput"
      @close="resetSubTestInput"
      @shown="clearInputField"
    >
      <test-input-modal
        :options.sync="options"
        :test-input.sync="subTestInput"
        test-level="subTest"
      />
    </b-modal>
    <b-modal
      ref="confirmDelete"
      title="ยืนยันการลบ"
      ok-title="ยืนยัน"
      cancel-title="ยกเลิก"
      @ok="delTest"
    >
      <confirm-modal />
    </b-modal>
  </b-container>
</template>

<script>
import { mapActions } from "vuex";
import ConfirmModal from "../../components/Settings/ConfirmModal";
import TestInputModal from "../../components/Settings/TestInputModal";
import Swal from "sweetalert2";

export default {
  name: "SubTest",
  components: {
    ConfirmModal,
    TestInputModal,
  },
  props: {
    subTests: {
      type: Array,
      default: () => [],
    },
    backHandler: {
      type: Function,
    },
    testTypeName: {
      type: String,
    },
    testTypeId: {
      type: Number,
    },
    testName: {
      type: String,
    },
    testId: {
      type: Number,
      default: null,
    },
    subTestId: {
      type: Number,
      default: null,
    },
    optionId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      isSubTest: false,
      fields: [
        {
          key: "sequence",
          label: "NO",
          isInputField: true,
          isSpecialField: true,
          fieldType: "number",
        },
        {
          key: "name",
          label: "NAME",
          isInputField: true,
          isSpecialField: false,
          fieldType: "text",
        },

        {
          key: "machine_id",
          label: "MACHINE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "selected",
          resources: [],
        },
        {
          key: "price",
          label: "PRICE",
          isInputField: true,
          isSpecialField: true,
          fieldType: "number",
        },
        {
          key: "unit.name",
          label: "UNIT",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
        {
          key: "abbreviation",
          label: "ABBREVIATION",
          isInputField: true,
          isSpecialField: true,
          fieldType: "text",
        },
        {
          key: "action",
          label: "ACTIONS",
          isInputField: false,
        },
      ],
      inputFields: [
        {
          key: "name",
          label: "Name",
          fieldType: "text",
          value: "",
          required: true,
          default: "",
        },
      ],
      itemSelected: null,
      modalTitle: "",
      deleteSpeciesIdSelected: null,
      previousId: null,
      subTestInput: {
        name: null,
        parent_type: "test",
        test_id: this.testId,
        sub_test_id: null,
        option_id: null,
        for_specie_id: null,
        price: null,
        machine_id: null,
        unit_id: null,
        abbreviation: null,
        has_sub_test: false,
        input_type: null,
        remark: null,
        display_ref_alert: null,
        display_abbreviation: false,
      },
      options: [],
    };
  },
  methods: {
    ...mapActions({
      getSubTests: "Settings/getSubTestListByTestId",
      getSubSubTests: "Settings/getSubTestListBySubTestId",
      getMachine: "Test/getMachine",
      getTestType: "Settings/getTestTypeList",
      createSubTest: "Settings/createSubTest",
      updateSubTest: "Settings/updateSubTest",
      deleteSubTest: "Settings/deleteSubTest",
      updateSequenceSubTest: "Settings/updateSequenceSubTest",
      getTestByTestTypeId: "Settings/getTestByTestTypeId",
    }),
    async openFieldModal(subTestId = null) {
      const subTestSelected = subTestId
        ? this.subTests.find((subTest) => subTest.id === subTestId)
        : null;
      if (subTestSelected) {
        this.subTestInput = Object.assign(
          {},
          {
            id: subTestSelected.id,
            parent_type: subTestSelected.parent_type,
            test_id: subTestSelected.test_id,
            sub_test_id: subTestSelected.sub_test_id,
            option_id: subTestSelected.option_id,
            for_specie_id: subTestSelected.for_specie_id,
            price: subTestSelected.price,
            machine_id: subTestSelected.machine_id,
            unit_id: subTestSelected.unit_id,
            abbreviation: subTestSelected.abbreviation,
            name: subTestSelected.name,
            has_sub_test: subTestSelected.has_sub_test,
            input_type: subTestSelected.input_type,
            remark: subTestSelected.remark,
            display_ref_alert: subTestSelected.display_ref_alert,
            display_abbreviation: subTestSelected.display_abbreviation,
          }
        );
      }

      if (
        this.subTestInput.input_type === "dropdown" ||
        this.subTestInput.input_type === "radio" ||
        this.subTestInput.input_type === "checkbox"
      ) {
        this.options = subTestSelected ? subTestSelected.test_option : [];
      }

      this.$refs["inputModal"].show();
    },
    openDeleteModal(subTestId) {
      this.deletesubTestIdSelected = subTestId;
      this.$refs["confirmDelete"].show();
    },
    async submit() {
      if (
        !this.subTestInput.parent_type ||
        !this.subTestInput.price ||
        !this.subTestInput.name ||
        !this.subTestInput.input_type
      ) {
        Swal.fire("ผิดพลาด", "ใส่ข้อมูลที่ต้องการไม่ครบ", "error");
        return;
      }
      if (
        this.subTestInput.parent_type === "test" &&
        !this.subTestInput.test_id
      ) {
        Swal.fire("ผิดพลาด", "ไม่มีข้อมูล test id", "error");
        return;
      }
      if (
        this.subTestInput.parent_type === "subTest" &&
        !this.subTestInput.sub_test_id
      ) {
        Swal.fire("ผิดพลาด", "ไม่มีข้อมูล sub id", "error");
        return;
      }
      if (
        this.subTestInput.parent_type === "option" &&
        !this.subTestInput.option_id
      ) {
        Swal.fire("ผิดพลาด", "ไม่มีข้อมูล option id", "error");
        return;
      }
      if (
        this.subTestInput.parent_type !== "test" &&
        this.subTestInput.has_sub_test
      ) {
        Swal.fire(
          "ผิดพลาด",
          "ไม่สามารถเพิ่มผลตรวจย่อยจากผลตรวจย่อยได้อีก",
          "error"
        );
        return;
      }

      if (
        this.subTestInput.input_type === "dropdown" ||
        this.subTestInput.input_type === "radio" ||
        this.subTestInput.input_type === "checkbox"
      ) {
        if (this.options.length === 0) {
          Swal.fire("ผิดพลาด", "ไม่มีข้อมูลตัวเลือก", "error");
          return;
        }
        this.subTestInput.options = this.options;
      }

      // if (this.subTestInput.price) {
      this.subTestInput.price = +this.subTestInput.price;
      // }

      for (const [key, value] of Object.entries(this.subTestInput)) {
        if (value === null) {
          delete this.subTestInput[key];
        }
      }

      if (this.subTestInput.options) {
        for (const option of this.subTestInput.options) {
          for (const [optionKey, optionValue] of Object.entries(option)) {
            if (optionValue === null) {
              delete option[optionKey];
            }
          }
        }
      }

      let res;
      if (this.subTestInput.id) {
        try {
          res = await this.updateSubTest(this.subTestInput);
        } catch (err) {
          this.$swal.fire(err);
        }
      } else {
        try {
          res = await this.createSubTest(this.subTestInput);
        } catch (err) {
          this.$swal.fire(err);
        }
      }

      if (res) {
        this.resetSubTestInput();
      }

      Swal.fire("สำเร็จ", "สร้างรายการตรวจเสร็จสิ้น", "success");
      this.$nextTick(async () => {
        let subTestUpdated;
        try {
          if (this.isSubTest) {
            subTestUpdated = await this.getSubSubTests(this.testId);
          } else {
            subTestUpdated = await this.getSubTests(this.testId);
          }

          this.$emit("update:subTests", subTestUpdated);
        } catch (e) {
          console.error(e);
          this.$store.state.isLoading = false;
        }
        this.$store.state.isLoading = false;
      });
      this.$refs["inputModal"].hide();
      this.itemSelected = null;
    },
    async backBtnHandler() {
      if (this.isSubTest) {
        let subTests;
        try {
          subTests = await this.getSubTestListByTestId(this.previousTestId);
        } catch (err) {
          console.error(err);
          return;
        }
        this.isSubTest = false;
        this.$nextTick(() => {
          this.$emit("update:testId", this.previousTestId);
          this.$emit("update:testName", this.previousTestName);
          this.$emit("update:subTests", this.subTests);
        });

        this.previousId = null;
        this.previousTestId = null;
        this.previousTestName = null;
        this.resetSubTestInput();
      } else {
        this.backHandler();
      }
    },
    clearInputField() {
      if (this.itemSelected) {
        this.inputFields.forEach((el) => {
          el.value = this.itemSelected[el.key];
        });
      } else {
        this.inputFields.forEach((el) => {
          el.value = "";
        });
      }
      this.modalTitle = this.itemSelected ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล";
    },
    async delTest() {
      let res = await this.deleteSubTest(this.deletesubTestIdSelected);
      this.deletesubTestIdSelected = null;
      try {
        let subTestUpdated = await this.getSubTests(this.testId);
      } catch (err) {
        console.error(err);
        return;
      }

      this.$emit("update:subTests", subTestUpdated);
      this.$refs["confirmDelete"].hide();
    },
    async changePositionHandler(id, type) {
      this.$store.state.isLoading = true;
      let prepareSequence = [];
      try {
        prepareSequence = this.subTest.map((item) => ({
          id: item.id,
          sequence: item.sequence,
        }));
        let itemChange = prepareSequence.find((item) => item.id === id);
        let newIndex =
          type === "up"
            ? itemChange.sequence === 1
              ? 1
              : itemChange.sequence - 1
            : itemChange.sequence === _.maxBy(prepareSequence, "sequence")
            ? _.maxBy(prepareSequence, "sequence")
            : itemChange.sequence + 1;
        prepareSequence.forEach((item) => {
          if (item.sequence === newIndex) {
            item.sequence =
              type === "up" ? item.sequence + 1 : item.sequence - 1;
          }
          if (item.id === id) {
            item.sequence = newIndex;
          }
        });
      } catch (e) {
        this.$store.state.isLoading = false;
      }

      try {
        await this.updateSequenceSubTest(prepareSequence);
      } catch (e) {}

      this.$nextTick(async () => {
        try {
          let subTestUpdated = await this.getSubTests(this.testId);

          this.$emit("update:subTests", subTestUpdated);
        } catch (e) {
          console.err(e);
          this.$store.state.isLoading = false;
        }
        this.$store.state.isLoading = false;
      });
    },
    checkMinMax(item, array, needle, type) {
      if (type === "min") {
        return item === _.minBy(array, needle)[needle];
      } else if (type === "max") {
        return item === _.maxBy(array, needle)[needle];
      }
    },
    resetSubTestInput() {
      this.subTestInput = {
        name: null,
        parent_type: this.isSubTest ? "subTest" : "test",
        test_id: !this.isSubTest ? this.testId : null,
        sub_test_id: this.isSubTest ? this.testId : null,
        option_id: null,
        for_specie_id: null,
        price: null,
        machine_id: null,
        unit_id: null,
        abbreviation: null,
        has_sub_test: false,
        input_type: null,
        remark: null,
        display_ref_alert: null,
        display_abbreviation: false,
      };
      this.options = [];
    },
    async openSubTestHandler(id) {
      let testName = this.subTests.find((subTest) => subTest.id === id).name;

      let subTests;
      try {
        subTests = await this.getSubSubTests(id);
      } catch (err) {
        console.err(err);
        return;
      }

      this.isSubTest = true;
      this.previousId = id;
      this.previoudTestId = this.testId;
      this.previoudTestName = this.testName;
      this.testId = id;

      this.$nextTick(() => {
        this.$emit("update:subTests", subTests);
        this.$emit("update:testId", id);
        this.$emit("update:testName", testName);
      });

      this.resetSubTestInput();
    },
  },
  watch: {
    subTestInput(value, oldValue) {},
  },

  async mounted() {
    // this.items = await this.getTests()
  },
};
</script>

<style lang="scss" scoped>
.icon {
  cursor: pointer;
  &.warning {
    color: #ffc107;
  }
  &.danger {
    color: #dc3545;
  }
  &.disable {
    opacity: 0.4;
    cursor: default;
  }
}
</style>
<style scoped></style>
